export default {
      id: "facebook-usage",
      viewBox: "0 0 21 20",
      url: "../dist/images/" + "sprite.svg#facebook-usage",
      toString: function () {
        return this.url;
      }
    }